import styled from 'styled-components';
import { THUMBNAIL_BORDER_SIZE } from '../consts';

/**
 * Separate thumb frame from element with the background image
 * to avoid complex calculations inside the Thumbnail component,
 * since the border size counts into the thumb width, affecting
 * background size and offset.
 */
export const ThumbnailFrame = styled.div`
  border-radius: 6px;
  border: ${THUMBNAIL_BORDER_SIZE}px solid #ccc;
  background-color: black;
  line-height: 0;
  flex-shrink: 0;
  overflow: hidden;
`;
